import { API_ORIGIN } from '../config'
const API_BASE = `${API_ORIGIN}/api`

export async function getExpenses(parkId, period) {
  const params = new URLSearchParams({ period })
  const response = await fetch(`${API_BASE}/parks/${parkId}/finance/expenses?${params}`)
  if (!response.ok) throw new Error('Error al obtener los gastos')
  return response.json()
}

export async function createExpense(parkId, data) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/finance/expenses`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  })
  if (!response.ok) throw new Error('Error al crear el gasto')
  return response.json()
}

export async function updateExpense(expenseId, data) {
  const response = await fetch(`${API_BASE}/expenses/${expenseId}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  })
  if (!response.ok) throw new Error('Error al actualizar el gasto')
  return response.json()
}

export async function deleteExpense(expenseId) {
  const response = await fetch(`${API_BASE}/expenses/${expenseId}`, { method: 'DELETE' })
  if (!response.ok) throw new Error('Error al eliminar el gasto')
  return response.json()
}

export async function getPlotOptions(parkId) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/finance/plot-options`)
  if (!response.ok) throw new Error('Error al obtener las naves')
  return response.json()
}

export async function getPlotExpenses(parkId, plotId) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/finance/plot-expenses?plotId=${encodeURIComponent(plotId)}`)
  if (!response.ok) throw new Error('Error al obtener los gastos de la nave')
  return response.json()
}